import { render, staticRenderFns, recyclableRender, components } from "./WuLiu-step.vue?vue&type=template&id=4a10f5fa&"
var renderjs
import script from "./WuLiu-step.vue?vue&type=script&lang=js&"
export * from "./WuLiu-step.vue?vue&type=script&lang=js&"
import style0 from "./WuLiu-step.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/WuLiu-step.vue"
export default component.exports